import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IAdditionalContact } from '@shs-digi-care-monorepo/interfaces';

@Component({
    selector: 'app-contact-information-detail',
    templateUrl: './contact-information-detail.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContactInformationDetail {
    public customerEmail = input<string | null>(null);
    public tasEmail = input<string | null>(null);
    public salesRepEmail = input<string | null>(null);
    public pmInstallationEmail = input<string | null>(null);
    public additionalContacts = input<IAdditionalContact[]>([]);
}
